var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-items-center d-flex stepper-element",class:{ active: _vm.isActive, pointer: !_vm.disabled },on:{"click":_vm.goToDestination}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }